<!-- 测试方式 -->
<template>
  <BaseFormItem
    class="test"
    :label="fields.label"
    :labelTips="fields.labelTips"
  >
    <BaseRadioGroup v-model="val" @change="handleEmit">
      <el-radio-button
        v-for="item in options"
        :key="item.value"
        :label="item.value"
        :disabled="item.disabled"
      >{{ item.label }}</el-radio-button>
    </BaseRadioGroup>

    <div slot="extend" class="test__tips">
      *100%AOl：免费，品质良率能达99%及以上，如要求100%请选择测试架（收费）测试
    </div>
  </BaseFormItem>
</template>

<script>
import { getCEM1Fields } from '@@/utils/getFields'
import { alertFieldsTips } from '@@/utils/alertFieldsTips'

export default {
  props: {
    value: {
      type: String,
      default: '100%AOI'
    },
    testOptions: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      val: this.value
    }
  },
  computed: {
    fields() {
      return getCEM1Fields('test')
    },
    options() {
      const { fields, testOptions } = this
      if (testOptions && testOptions.length > 0) {
        return testOptions.map(({ real, word }) => ({ label: word, value: real }))
      }
      
      return fields.options
    }
  },
  watch: {
    value(newVal) {
      if (this.val != newVal && this.val == '抽测') { 
        this.changeVal(newVal)
      }
      this.val = newVal
    },
    testOptions(testOptions) {
      this.testOptions = testOptions
    }
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)
    },
    changeVal(val) {
      alertFieldsTips(this.fields.label)
      this.val = val
      this.handleEmit()
    }
  }
}
</script>

<style lang="scss" scoped>
.test {
  .test__tips {
    width: 100%;
    font-size: 12px;
    color: $--color-warning;
  }
}
</style>